import { useEffect,useState } from "react";

export const useCurrentTime = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const formatTime = (date: Date) => {
        return date.toLocaleTimeString("id-ID", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    };

    const formatDate = (date: Date) => {
        return date.toLocaleDateString("id-ID", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    };

    // Time format for video player overlay (DD MMM YYYY | HH:mm:ss WIB)
    const formatOverlayTime = (date: Date) => {
        const dateStr = date.toLocaleDateString("id-ID", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
        const timeStr = date.toLocaleTimeString("id-ID", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
        return `${dateStr} | ${timeStr} WIB`;
    };

    return {
        currentTime,
        formatTime,
        formatDate,
        formatOverlayTime,
        formattedOverlay: formatOverlayTime(currentTime)
    };
};
